import {
  PURE_DATA_FOR_STRING_REGEX,
  QUOT_REGEX,
  SPECIAL_CHAR_REGEX,
} from "@/constants/regex"
import {
  getLinkFromHref,
  makingTextDatalayerReady,
  pushAnalyticsObjToDataLayer,
  removeAndCleanLink,
} from "@/utils/helper"
import { sanitizedTextAndEntities } from "@/utils/index"
import {
  HOW_TO_BECOME_A_KPN,
  JOIN_NOW,
  TWO_WAYS_TO_BE_A_KPN,
  INSPIRATION_PAGE_NAME,
  BROWSE_ALL_KOHLER_STORES,
  MORE_OPTIONS,
  PAGE_TYPES,
  FIND_A_STORE,
  PDP_DETAILS,
  HERO_BANNER,
  BUYING_GUIDE,
  SHOP_THE_LOOK,
  COMPONENT_TYPES,
  GIFT_DESIGN,
  KOHLER_BATHROOM_DESIGN,
  FRIENDS_AND_FAMILY_PROGRAM,
  KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP,
} from "@/constants/index"

export const getEventInfo = (
  pageType = "",
  componentPosition = "",
  mainTitle = "",
  eventLabel = "",
  dataLayerLinkType = "",
  eventType = "",
  zone = "",
  parseJson = false
) => {
  const zoneName = zone ? zone?.replace(SPECIAL_CHAR_REGEX, " ") : "zone"
  let internalLinkType = ""
  if (eventLabel === "print") {
    internalLinkType = `${pageType.toLowerCase()}:${mainTitle.toLowerCase()}:print`
  } else {
    internalLinkType = `${dataLayerLinkType}`
  }

  const internalLinkZoneName = zone
    ? `${pageType.toLowerCase()}:${zoneName}`
    : "teaser"

  const eventInfo = {
    clickInternalLinks: "true",
    internalLinkPosition: `${pageType.toLowerCase()}:${
      componentPosition ? componentPosition : "teaser"
    }`,
    internalLinkZoneName,
    internalLinkURL: "n/a",
    internalLinkName: `${eventLabel}`,
    eventName: `${pageType.toLowerCase()}:${
      eventLabel === "print" ? eventLabel : `${zoneName}:share`
    }`,
    internalLinkType: internalLinkType,
    eventType: eventType,
    eventAction: `${pageType.toLowerCase()}:${
      eventLabel === "print" ? eventLabel : `${zoneName}:share`
    }`,
  }
  if (parseJson) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const addDatalayerShare = (data = "{}", isPdp = false) => {
  const page = window.pageObj || {}
  const eventInfo = JSON.parse(data)
  const dataLayerObj = {
    event: "cmp:click",
    page,
    eventInfo,
  }
  if (isPdp) {
    const { productInfo } = page
    dataLayerObj["productInfo"] = productInfo
  }
  window.adobeDataLayer.push(dataLayerObj)
}

export const getDownloadEventInfo = (
  downLoadLink = "",
  pageType = "",
  componentPosition = "",
  mainTitle = "",
  dataLayerLinkType = ""
) => {
  let eventInfo = {}
  if (downLoadLink) {
    eventInfo = {
      clickInternalLinks: "true",
      internalLinkPosition: `${pageType.toLowerCase()}:${
        componentPosition ? componentPosition : "teaser"
      }`,
      internalLinkZoneName: "teaser",
      internalLinkURL: `${downLoadLink}`,
      internalLinkName: "download",
      eventName: `${pageType.toLowerCase()}:download`,
      internalLinkType: `${pageType.toLowerCase()}:${mainTitle.toLowerCase()}:download`,
      eventType: "teaser",
      eventAction: `${pageType.toLowerCase()}:download`,
    }
  } else {
    eventInfo = {
      clickInternalLinks: "true",
      internalLinkPosition: `${pageType.toLowerCase()}:${
        componentPosition || "teaser"
      }`,
      internalLinkZoneName: "teaser",
      internalLinkURL: "n/a",
      internalLinkName: "download",
      eventName: `${pageType.toLowerCase()}:download`,
      internalLinkType: `${dataLayerLinkType}`,
      eventType: "teaser",
      eventAction: `${pageType.toLowerCase()}:download`,
    }
  }

  return JSON.stringify(eventInfo)
}

export const getTitleEventInfo = (
  linkNewTab = false,
  componentPosition = "",
  linkURL = "",
  mainTitle = "",
  pageType = "",
  componentLinkType = "",
  title = ""
) => {
  return `{"clickInternalLinks":"${
    linkNewTab || mainTitle.toLowerCase().includes("kohler canada")
      ? "false"
      : "true"
  }","internalLinkPosition":"${pageType?.toLowerCase()}:${
    componentPosition || "teaser"
  }","internalLinkZoneName":"teaser","internalLinkURL":"${
    linkURL || getLinkFromHref(title)
  }","internalLinkName":"${mainTitle.toLowerCase()}","eventName":"${pageType.toLowerCase()}:zone:${mainTitle.toLowerCase()}","internalLinkType":"${pageType}:${
    componentLinkType ? componentLinkType : mainTitle.toLowerCase()
  }","eventType":"teaser","eventAction":"${pageType.toLowerCase()}:zone:${mainTitle.toLowerCase()}"}`
}

export const addTeaserActionAnalytics = ({
  pageType = "",
  componentPosition = "",
  videoTitle = "",
  link = "",
  text = "",
  eventName: eventNameDatalayer,
  dataLayerLinkType = "",
  eventAction: eventActionDataLayer,
  productCategory = "",
  productCollectionsName = "",
  productRoom = "",
  datalayerPageType = "",
  mainTitle = "",
  componentInfo = "",
}) => {
  const eventTitle = makingTextDatalayerReady(mainTitle)
  let internalLinkZoneName
  let internalLinkName
  const eventPageType = pageType?.toLowerCase()
  const linkText = text?.toLowerCase()
  let eventAction = eventPageType
    ? `${eventPageType}:${
        eventActionDataLayer?.toLowerCase() || eventTitle || "zone"
      }:${linkText}`
    : `${
        eventActionDataLayer?.toLowerCase() || eventTitle || "zone"
      }:${linkText}`

  let eventName = eventAction

  if (videoTitle || eventPageType === "plp") {
    eventAction = `${eventPageType}:${videoTitle}:${linkText}`
    eventName = `${eventPageType}:${videoTitle}:${linkText}`
    internalLinkZoneName = `${eventPageType}:${videoTitle}`
  } else if (eventTitle) {
    internalLinkZoneName = `${eventPageType}:${eventTitle}`
  } else {
    internalLinkZoneName = "teaser"
  }
  let internalLinkPosition = eventPageType
    ? `${eventPageType}:${componentPosition || "teaser"}`
    : componentPosition || "teaser"

  let internalLinkType = videoTitle.replace(PURE_DATA_FOR_STRING_REGEX, "")
    ? `${`${eventPageType}:${videoTitle.replace(
        PURE_DATA_FOR_STRING_REGEX,
        ""
      )}`}`
    : eventPageType
    ? `${eventPageType}:${eventTitle}`
    : "navigation"

  if (dataLayerLinkType.includes("social impact")) {
    eventName = `${dataLayerLinkType.substring(
      0,
      dataLayerLinkType.lastIndexOf(":")
    )}:${text?.toLowerCase()}`
    eventAction = `${dataLayerLinkType.substring(
      0,
      dataLayerLinkType.lastIndexOf(":")
    )}:${text?.toLowerCase()}`
    internalLinkZoneName = `${dataLayerLinkType.substring(
      0,
      dataLayerLinkType.lastIndexOf(":")
    )}`
  }
  let eventType = "navigation"
  if (datalayerPageType.includes("locations")) {
    pageType = "locations:kohler stores"
    eventName = `${eventPageType}:${linkText}`
    eventAction = `${eventPageType}:${linkText}`
    internalLinkZoneName = eventPageType
    internalLinkPosition = `${eventPageType}:teaser`
    internalLinkType = `${eventPageType}:${eventTitle}`
  }
  const page = window.pageObj || {}
  if (
    text === "Apply Now" &&
    eventActionDataLayer === null &&
    eventPageType === "friends and family program"
  ) {
    eventAction = `${FRIENDS_AND_FAMILY_PROGRAM}:${KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP}:${linkText}`
    eventName = `${FRIENDS_AND_FAMILY_PROGRAM}:${KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP}:${linkText}`
    eventType = "teaser"
    internalLinkPosition = `${FRIENDS_AND_FAMILY_PROGRAM}:teaser`
    internalLinkType = `${FRIENDS_AND_FAMILY_PROGRAM}:${KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP}`
    internalLinkZoneName = `${FRIENDS_AND_FAMILY_PROGRAM}:${KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP}`
    internalLinkName = linkText
  } else if (text === "Apply Now" && eventActionDataLayer === null) {
    const datalayerPageType = page?.category?.pageType
    const NewDatalayerPageType =
      datalayerPageType === "services"
        ? page?.category?.subCategoryID
        : datalayerPageType
    eventAction = linkText
    eventName = linkText
    eventType = "promo banner"
    internalLinkPosition = `${NewDatalayerPageType?.toLowerCase()}:promo banner`
    internalLinkType = eventPageType
      ? `${eventPageType}:${eventTitle}`
      : "navigation"
    internalLinkZoneName = `${NewDatalayerPageType?.toLowerCase()}:promo details`
  } else if (text === BUYING_GUIDE) {
    eventName = `${eventPageType}:${HERO_BANNER}:${linkText}`
    eventAction = `${eventPageType}:${HERO_BANNER}:${linkText}`
    internalLinkName = `${BUYING_GUIDE.toLowerCase()}`
    internalLinkZoneName = `${eventPageType}:${HERO_BANNER}`
  }
  if (
    (linkText === BROWSE_ALL_KOHLER_STORES ||
      text === MORE_OPTIONS.LEARN_MORE) &&
    datalayerPageType === "locations"
  ) {
    pageType = `${FIND_A_STORE}:${PAGE_TYPES.LOCATION_LANDING_PAGE}`
    eventName = `${pageType}:${linkText}`
    eventAction = `${pageType}:${linkText}`
    internalLinkPosition = FIND_A_STORE
    internalLinkType = `${FIND_A_STORE}:${
      (text === MORE_OPTIONS.LEARN_MORE && eventTitle) || eventType
    }`
    internalLinkZoneName = `${pageType}${
      (text === MORE_OPTIONS.LEARN_MORE && ":" + eventTitle) || ""
    }`
  }
  if (eventPageType === HOW_TO_BECOME_A_KPN) {
    eventName = `${eventPageType}:${
      text === JOIN_NOW ? TWO_WAYS_TO_BE_A_KPN : mainTitle?.toLowerCase()
    }:${linkText}`
    eventAction = `${eventPageType}:${
      text === JOIN_NOW ? TWO_WAYS_TO_BE_A_KPN : mainTitle?.toLowerCase()
    }:${linkText}`
    internalLinkZoneName = `${eventPageType}:${
      text === JOIN_NOW ? TWO_WAYS_TO_BE_A_KPN : mainTitle?.toLowerCase()
    }`
    eventType = "teaser"
    internalLinkPosition = `${eventPageType}:teaser`
  }
  if (window.eventPageType === "pdp" && text === "Shop Farmstead") {
    eventName = `${window.eventPageType?.toLowerCase()}:farmstead sink:${linkText}`
    eventAction = `${window.eventPageType?.toLowerCase()}:farmstead sink:${linkText}`
    eventType = "navigation"
    internalLinkPosition = `pdp:${pageType?.toLowerCase()}`
    internalLinkType = `pdp:${pageType?.toLowerCase()}`
    internalLinkZoneName = PDP_DETAILS
  }
  if (mainTitle === GIFT_DESIGN) {
    eventType = COMPONENT_TYPES.TEASER
    internalLinkType = `${eventPageType}:${KOHLER_BATHROOM_DESIGN}`
  }
  const eventInfo = {
    clickInternalLinks:
      link?.startsWith("/") ||
      link?.startsWith("#") ||
      link?.includes(window.location.hostname)
        ? "true"
        : "false",
    internalLinkPosition,
    internalLinkZoneName,
    internalLinkURL: link
      ? `${
          link.indexOf("http") === -1 ? window.location.origin : ""
        }${removeAndCleanLink(link)}`
      : "n/a",
    internalLinkName:
      internalLinkName || `${!text ? "explore more arrow" : linkText}`,
    eventName,
    internalLinkType,
    eventType,
    eventAction,
    eventMsg: "n/a",
    eventStatus: "n/a",
  }

  const customDataLayer = {
    ...(componentInfo ? { componentInfo: JSON.parse(componentInfo) } : {}),
    productInfo: {
      productCategory: productCategory || "n/a",
      productCollectionsName: productCollectionsName || "n/a",
      productRoom: productRoom || "n/a",
    },
  }

  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, customDataLayer)
}

export const addTeaserDescriptionAnalytic = (
  target = "",
  isPdp = "",
  isPlp = "",
  pageType = "",
  internalLinkPositionNotPdp = "",
  preTitle = "",
  mainTitle = "",
  linkURL = "",
  internalLinkTypeNotPdp = "",
  sanitizeDescription = ""
) => {
  return JSON.stringify({
    clickInternalLinks: target === "_blank" ? "false" : "true",
    internalLinkPosition:
      isPdp || isPlp ? pageType.toLowerCase() : internalLinkPositionNotPdp,
    internalLinkZoneName: isPlp
      ? `${pageType.toLowerCase()}:${preTitle}:rm`
      : mainTitle
      ? `${pageType?.toLowerCase()}:${mainTitle}`
      : "teaser",
    internalLinkURL: linkURL,
    eventName: isPlp
      ? `${pageType.toLowerCase()}:${preTitle}:rm`
      : `${pageType.toLowerCase()}:${mainTitle}:${sanitizeDescription}`,
    internalLinkType: isPdp
      ? `${pageType.toLowerCase()}:teaser`
      : isPlp
      ? `${pageType.toLowerCase()}:navigation`
      : internalLinkTypeNotPdp,
    eventType: isPdp || isPlp ? "navigation" : "teaser",
    internalLinkName: sanitizeDescription,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventAction: isPlp
      ? `${pageType.toLowerCase()}:${preTitle}:rm`
      : `${pageType.toLowerCase()}:${mainTitle}:${sanitizeDescription}`,
  })
}

export const addTeaserAnalytic = (
  e,
  linkNewTab = false,
  componentPosition = "",
  linkURL = "",
  mainTitle = "",
  pageType = "",
  componentLinkType = "",
  title,
  datalayerLinkName = "",
  containerIdName = "",
  eventName = "",
  eventAction = ""
) => {
  e.preventDefault()
  return `{"clickInternalLinks":"${
    linkNewTab ? "false" : "true"
  }","internalLinkPosition":"${pageType?.toLowerCase()}:${
    componentPosition || "teaser"
  }","internalLinkZoneName":"teaser","internalLinkURL":"${linkURL}","internalLinkName":"${datalayerLinkName}","eventName":"${pageType?.toLowerCase()}:${containerIdName}:${
    eventName || datalayerLinkName || "rm"
  }","internalLinkType":"${pageType}:${
    componentLinkType || mainTitle
  }","eventType":"teaser","eventAction":"${pageType?.toLowerCase()}:${containerIdName}:${
    eventAction || datalayerLinkName || "rm"
  }"}`
}

export const addTeaserLinkAnalytics = (
  teaserFullData,
  link,
  bodytitle,
  containerId,
  data,
  datalayerPageName,
  linkURL
) => {
  const {
    datalayerLinkName,
    fullData,
    mainTitle,
    eventAction,
    eventName,
    linkNewTab,
  } = data
  const {
    teaser: {
      pretitle: teaserPretitle = "",
      mainTitle: teaserMainTitle = "",
    } = {},
  } = teaserFullData || {}
  const page = window.pageObj || {}
  const {
    pageInfo: { pageUrl },
    productInfo,
  } = page
  const pageType = window.eventPageType
  const internalLinkName = sanitizedTextAndEntities(datalayerLinkName)

  if (pageType === "pdp") {
    const eventInfo = {
      eventAction: `pdp:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : "product details"
      }:${sanitizedTextAndEntities(eventAction || mainTitle)
        .toLowerCase()
        .trim()}`,
      eventName: `pdp:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : "product details"
      }:${sanitizedTextAndEntities(eventName || mainTitle)
        .toLowerCase()
        .trim()}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName,
      internalLinkPosition: "pdp",
      internalLinkType: `pdp:teaser`,
      internalLinkZoneName: `pdp:${sanitizedTextAndEntities(
        fullData?.teaser?.mainTitle || bodytitle
      )
        .toLowerCase()
        .trim()}`,
      internalLinkURL: `${window.location.href || link || pageUrl || "n/a"}`,
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
      productInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  } else if (pageType === INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR) {
    const eventInfo = {
      eventAction: `${pageType}:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : containerId.replaceAll("-", " ")
      }:${eventAction || mainTitle}`,
      eventName: `${pageType}:${
        fullData?.teaser?.mainTitle
          ? fullData?.teaser?.mainTitle
          : containerId.replaceAll("-", " ")
      }:${eventName || mainTitle}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${datalayerLinkName}`,
      internalLinkPosition: `${pageType}:teaser`,
      internalLinkType: `${pageType}:${containerId.replaceAll("-", " ")}`,
      internalLinkZoneName: `${pageType}:${
        fullData?.teaser?.mainTitle || containerId.replaceAll("-", " ")
      }`,
      internalLinkURL: `${window.location.href || link || pageUrl || "n/a"}`,
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  } else if (pageType === "home with shea mcgee") {
    const linkPosition = datalayerPageName.split(":")[0]
    const eventInfo = {
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
      internalLinkPosition: linkPosition,
      eventMsg: "n/a",

      internalLinkZoneName: `${pageType}:${linkURL}`,
      internalLinkURL: `${linkURL}`,
      internalLinkName: mainTitle,
      internalLinkType: `${linkPosition}:${pageType}`,
      eventType: "navigation",
      eventAction: `${pageType?.toLowerCase()}:${linkURL}:${mainTitle}`,
      eventName: `${pageType?.toLowerCase()}:${linkURL}:${mainTitle}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  } else if (
    pageType?.toLowerCase() === INSPIRATION_PAGE_NAME.PROJECT_GALLERY
  ) {
    addProjectGalleryAnalytics(
      linkNewTab,
      pageType?.toLowerCase(),
      linkURL?.toLowerCase(),
      link,
      mainTitle?.toLowerCase(),
      teaserPretitle?.toLowerCase()
    )
  } else if (pageType === "plp") {
    const preTitle = document
      .querySelector(".cmp-teaser__pretitle p")
      ?.textContent.toLowerCase()
    const eventInfo = {
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
      internalLinkPosition: pageType,
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkZoneName: `${pageType}:${linkURL}`,
      internalLinkURL: `${window.location.origin}${link}`,
      internalLinkName: mainTitle,
      internalLinkType: `${pageType}:${preTitle}:${linkURL}`,
      eventType: "carousel",
      eventAction: `${pageType?.toLowerCase()}:${linkURL}:${mainTitle}`,
      eventName: `${pageType?.toLowerCase()}:${linkURL}:${mainTitle}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  } else if (pageType.toLowerCase().includes("my account")) {
    const eventNameAction = `${pageType}:${
      fullData?.teaser?.mainTitle
        ? fullData?.teaser?.mainTitle
        : containerId.replaceAll("-", " ")
    }:${eventAction || mainTitle}`
    const eventInfo = {
      eventAction: eventNameAction.replace(QUOT_REGEX, ""),
      eventName: eventNameAction.replace(QUOT_REGEX, ""),
      eventType: "teaser",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${datalayerLinkName}`.replace(QUOT_REGEX, ""),
      internalLinkPosition: `${pageType}:teaser`,
      internalLinkType: `${pageType}:${containerId.replaceAll("-", " ")}`,
      internalLinkZoneName: `${pageType}:${
        fullData?.teaser?.mainTitle || containerId.replaceAll("-", " ")
      }`,
      internalLinkURL: `${window.location.href || link || pageUrl || "n/a"}`,
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  } else {
    const eventNameAction = `${pageType}:${
      teaserMainTitle ? teaserMainTitle : containerId.replaceAll("-", " ")
    }:${eventAction || mainTitle}`
    const internalLinkTypeAction = ` ${
      teaserMainTitle ? teaserMainTitle : containerId.replaceAll("-", " ")
    }`
    const eventInfo = {
      eventAction: eventNameAction.replace(QUOT_REGEX, ""),
      eventName: eventNameAction.replace(QUOT_REGEX, ""),
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `${datalayerLinkName}`.replace(QUOT_REGEX, ""),
      internalLinkPosition: `${pageType}:teaser`,
      internalLinkType: `${pageType}:${internalLinkTypeAction}`,
      internalLinkZoneName: `${pageType}:${internalLinkTypeAction}`,
      internalLinkURL: `${window.location.href || link || pageUrl || "n/a"}`,
      clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    }
    const dataLayerObj = {
      event: "cmp:click",
      page,
      eventInfo,
    }
    window.adobeDataLayer.push(dataLayerObj)
  }
}

const addProjectGalleryAnalytics = (
  linkNewTab,
  page,
  teaserTitle,
  linkUrl,
  mainTitle,
  teaserPretitle
) => {
  const title = makingTextDatalayerReady(mainTitle)
  const eventInfo = {
    clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
    internalLinkPosition: `${page}:teaser`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkZoneName: `${page}:${teaserPretitle || teaserTitle}`,
    internalLinkURL: `${window.location.origin}${linkUrl}`,
    internalLinkName: title,
    internalLinkType: `${page}:${teaserTitle}`,
    eventType: "navigation",
    eventAction: `${page}:${teaserPretitle || teaserTitle}:${title}`,
    eventName: `${page}:${teaserPretitle || teaserTitle}:${title}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const getCaptionLinkEventInfo = (pageType, linkTextToMatch, link) => {
  if (linkTextToMatch?.toLowerCase().includes(SHOP_THE_LOOK)) {
    return {
      clickInternalLinks: "true",
      eventAction: `${pageType}:shop by category:${SHOP_THE_LOOK}`,
      eventMsg: "n/a",
      eventName: `${pageType}:shop by category:${SHOP_THE_LOOK}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: SHOP_THE_LOOK,
      internalLinkPosition: `${pageType}:teaser`,
      internalLinkType: `${pageType}:shop by category`,
      internalLinkURL: link
        ? `${
            link.indexOf("http") === -1 ? window.location.origin : ""
          }${removeAndCleanLink(link)}`
        : "n/a",
      internalLinkZoneName: `${pageType}:shop by category`,
    }
  }

  return {}
}
